import { round } from '../units_helpers';
import type { SelectOptionPropsType } from '@Shelly/shelly-design-system/index';

export type TemperatureUnit = 'C' | 'F';

const OPTIONS: TemperatureUnit[] = ['C', 'F'];

const convertTemperatureFromC = (valueC: number, unit: TemperatureUnit): number => {
	if (!Number.isFinite(valueC)) return NaN;
	return unit === 'F' ? valueC * (9 / 5) + 32 : valueC;
};

const temperatureUnitLabel = (unit: TemperatureUnit): string => {
	return unit === 'F' ? '°F' : '°C';
};

export const getTemperatureUnitOptions = (): SelectOptionPropsType[] => {
	return OPTIONS.map((u) => ({ title: temperatureUnitLabel(u), value: u }));
};

export const convertTemperature = (value: number, unit: TemperatureUnit): string => {
	if (!Number.isFinite(value)) return '--';
	const temp = convertTemperatureFromC(value, unit);
	return `${round(temp)} ${temperatureUnitLabel(unit)}`;
};
